module.exports = __webpack_public_path__ + "static/communitymedicalgroup-dc4c5559f049db8ca902f43ed5c133e8.jpg";